var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_5_1.png"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "smallSize": "",
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 3) ? [_c('div', {
    staticClass: "container mt-50"
  }, _vm._l((_vm.menuList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "mb-20 flex-container-row"
    }, [_c('a', {
      staticClass: "bold item-title mr-20 color-fff fs-20 flex-container nav_title",
      on: {
        "click": function($event) {
          return _vm.toNav(v)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(v.title))])]), _vm._v(" "), (v.subMenu.length) ? [_c('div', {
      staticClass: "flex-container-row_wrap"
    }, _vm._l((v.subMenu), function(sv, si) {
      return _c('a', {
        key: si,
        staticClass: "item-subTitle mr-20  color-fff fs-20 flex-container",
        on: {
          "click": function($event) {
            return _vm.toSubUrl(v, sv, si)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(sv.subTitle))])])
    }), 0)] : _vm._e()], 2)
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "color-fff fs-20 mt-50 mb-50",
    attrs: {
      "stlye": "text-indent:2em;"
    }
  }, [_vm._v("\n           \n          " + _vm._s(_vm.$t("friendlylink.legalStatement")) + "\n      ")])])] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 2) ? [_c('div', {
    staticClass: "container text-center color-ccc fs-20"
  }, [_c('b-container', [_c('b-row', _vm._l((_vm.linkList), function(v, i) {
    return _c('b-col', {
      key: i,
      attrs: {
        "xs": "6",
        "sm": "6",
        "md": "4",
        "lg": "2"
      }
    }, [_c('div', {
      staticClass: "item mt-40 text-center img_wrap"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (v.img),
        expression: "v.img"
      }]
    }), _vm._v(" "), _c('a', {
      staticClass: "fs-16 mt-20",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(v.title))])])])
  }), 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 0) ? [_c('div', {
    staticClass: "container flex-container-row justify-spacebeteen"
  }, [_c('div', {
    staticClass: "mb-50 color-fff mt-50 fs-20 lh-custom flex-1"
  }, [_c('div', {
    staticClass: "consult-section"
  }, [_c('div', {
    staticClass: "consult-title"
  }, [_vm._v(_vm._s(_vm.$t('friendlylink.consult.preRegTitle')) + "：")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "consult-section"
  }, [_c('div', {
    staticClass: "consult-title"
  }, [_vm._v(_vm._s(_vm.$t('friendlylink.consult.mediaTitle')) + "：")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "consult-section"
  }, [_c('div', {
    staticClass: "consult-title"
  }, [_vm._v(_vm._s(_vm.$t('friendlylink.consult.groupTicketTitle')) + "：")]), _vm._v(" "), _vm._m(2)])])])] : _vm._e(), _vm._v(" "), _c('page-footer')], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consult-lines"
  }, [_c('div', {
    staticClass: "consult-line"
  }, [_c('span', [_vm._v("020-89138238")]), _c('span', [_vm._v("020-89138041")])]), _vm._v(" "), _c('div', {
    staticClass: "consult-line"
  }, [_c('span', [_vm._v("020-89138206")]), _c('span', [_vm._v("020-89138019")])]), _vm._v(" "), _c('div', {
    staticClass: "consult-line"
  }, [_c('span', [_vm._v("020-89138078")]), _c('span', [_vm._v("020-89138214")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consult-lines"
  }, [_c('div', {
    staticClass: "consult-line"
  }, [_c('span', [_vm._v("020-89138049")]), _c('span', [_vm._v("020-89138025")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consult-lines"
  }, [_c('div', {
    staticClass: "consult-line"
  }, [_c('span', [_vm._v("020-89138182")])])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a24a526","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/friendlyLink/index.vue
// module id = null
// module chunks = 